export enum AuthStateType {
  INITIALIZING = "INITIALIZING",
  UNKNOWN = "UNKNOWN",
  GUEST = "GUEST",
  LOGIN_USER = "LOGIN_USER",
}



// WEBPACK FOOTER //
// ./src/presentation/auth_state_type.ts